import type { TrackingEvent, TrackingPayload } from '~/types/tracking'

const useFilterEvents = (
  track: (event: TrackingEvent, payload: TrackingPayload) => void,
) => ({
  trackFilterApply: (label: string) => {
    track('plp_filter_applied', {
      action: 'applied',
      label,
      category: 'plp_filter',
    })
  },

  trackFilterFlyout: (action: string, label: string) => {
    track('filter_flyout', {
      action,
      label,
    })
  },
})

export default useFilterEvents
